import SingleSignOnSessionManager from '@/stand-alone/single-sign-on-session-manager';

export default class LogInComponent {
	private singleSignOnSessionManager = new SingleSignOnSessionManager();

	public async signInClient(): Promise<void> {
		await this.singleSignOnSessionManager.loginClient();
	}
}
